import React from "react";
import { Link } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { useNavContext } from "../context-api/nav-context";

const CallToAction = ({ data }) => {
  const { callToActionTitle, callToActionSubTitle, callToActionText } = data[4];
  const { closeNavbarMenu } = useNavContext();
  return (
    <section className="home-values" onMouseOver={closeNavbarMenu}>
      <div className="wrapper two-columns">
        <div className="home-values-left">
          <h1 className="title title-value">{callToActionTitle}</h1>
          <Link to="/boilers" className="btn-hero btn-quote btn-home-values">
            Find Out More <BsArrowRightShort class="btn-arrow" />
          </Link>
          <article className="home-values-text">
            <h3 className="home-values-subtitle">{callToActionSubTitle}</h3>
            <p className="home-values-p">{callToActionText}</p>
          </article>
        </div>
        <div className="home-values-right">
          <div className="home-values-images">
            <img
              src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_100,w_700/v1642186287/AquaHeat/Home%20values/boiler-callout_tpwgsj.webp"
              alt="AquaHeat bolier and plumbing callout services"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
